import React, { useEffect, useState } from 'react';
import HeroSlider from './HeroSlider';
import Sidebar from './Sidebar';
import AdsSection from './AdsSection';
import { Link } from 'react-router-dom';
import Marquee from './Marquee';

interface Ad {
  id: number;
  title: string;
  description: string;
  contentUrl: string;
  linkUrl: string;
  section: string;
}

const AdLayout = () => {
  const [sidebarAds, setSidebarAds] = useState<Ad[]>([]);
  const API_BASE_URL = 'http://localhost:2026';

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/ads`)
      .then((res) => res.json())
      .then((data) => {
        const filtered = data.filter((ad: any) => ad.section === 'sidebar');
        setSidebarAds(filtered);
      })
      .catch((err) => console.error("Error fetching sidebar ads:", err));
  }, []);

  const renderAds = () => {
    if (sidebarAds.length === 0) {
      return (
      <div className="px-3 py-2 text-center text-gray-400 border rounded-md h-16 flex items-center justify-center text-xs">
  Loading Offers...
</div>


      );
    }

    return sidebarAds.map((ad, index) => {
      const isStyleOne = index % 2 === 0;

      return (
        <div
  key={ad.id}
  className="relative bg-cover bg-center rounded-lg shadow-md border border-gray-200 h-42 flex items-center justify-center text-center mb-4 mx-2"
  style={{
    backgroundImage: `url('${API_BASE_URL}${ad.contentUrl}')`,
    minWidth: '400px', // Mobile par card thoda bada dikhe isliye 300px kiya
    // minHeight: '200px',
  }}
>
          <div className="absolute inset-0  rounded-lg "></div>
          <div className="relative z-10 p-6 text-left w-full">
            <h3 className={`text-xl font-bold mb-2 ${isStyleOne ? 'text-red-600' : 'text-white'}`}>
              {ad.title}
            </h3>
            <p className={`text-sm mb-4 ${isStyleOne ? 'text-black' : 'text-white font-semibold'}`}>
              {ad.description}
            </p>
            <Link to={ad.linkUrl}>
              <button 
                className={`w-32 text-white font-semibold py-2 px-4 rounded-md transition-colors duration-300 ${
                  isStyleOne 
                    ? 'bg-orange-500 hover:bg-orange-600' 
                    : 'bg-green-500 hover:bg-green-600'
                }`}
              >
                Check Now
              </button>
            </Link>
          </div>
        </div>
      );
    });
  };

  return (
    <>
      <div className="flex flex-col lg:flex-row justify-between items-start gap-4 p-4">
        
        {/* Sidebar Logic: 
            Mobile pe 'hidden' (kyunki header me menu hai). 
            Desktop (lg) pe 'block'.
        */}
        <div className="hidden lg:block">
           <Sidebar />
        </div>
        
        {/* Container for Side Ads & Hero Slider 
            Mobile pe: Hero upar (order-1), Ads niche (order-2)
            Desktop pe: Ads left, Hero right (Flex row behavior)
        */}
        
        {/* Side Ad Cards Container */}
        <div className="w-full lg:w-1/4 flex flex-col gap-4 overflow-hidden order-2 lg:order-none pt-4">
          {sidebarAds.length > 1 ? (
            <Marquee>
               {renderAds()}
            </Marquee>
          ) : (
            <div className="flex flex-col w-full">
               {renderAds()}
            </div>
          )}
        </div>

        {/* Main Hero Slider */}
        <div className="w-full lg:w-4/5 order-1 lg:order-none">
          <HeroSlider />
        </div>
      </div>

      <AdsSection />
    </>
  );
};

export default AdLayout;